import React,{Component}from 'react';
import Todoitem from './Todoitem.js'
import PropTypes from 'prop-types'
class Todos extends Component{

render(){

  return (
    <div>{this.props.todos.map((todo)=>{
        return <Todoitem  key={todo.id} todo={todo} ontoggle={this.props.ontoggle} deltodo={this.props.deltodo} />
      })
    }
    </div>
    
  ) 
}
}
// PropTypes
Todos.propTypes ={
  todos:PropTypes.array.isRequired,
  ontoggle: PropTypes.func.isRequired,
  deltodo: PropTypes.func.isRequired
}
export default Todos;


